import React from 'react'
import { StyledCalender } from 'components/CalendarPicker/Style/style'

const CalendarPicker = ({
  multiple = false,
  value = null,
  onCalenderChange,
  numberOfMonths = 1,
  disabledDate,
  minDate,
  required = false,
}) => {
  return (
    <StyledCalender
      multiple={multiple}
      numberOfMonths={numberOfMonths}
      value={value}
      onChange={onCalenderChange}
      disabledDate={disabledDate}
      minDate={minDate}
      required={required}
    />
  )
}

export default CalendarPicker
